"use strict";

import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class ProductService {
    // 'Use-Virtual-Session' - used on SiteSelector (runs in VirtualSession)
    getVirtualProductById (virtualProductId) {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + "virtualproducts/" + virtualProductId, {
                headers: {
                    "Use-Virtual-Session": true
                }
            });
    }

    getAllVirtualProducts () {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + "virtualproducts", {
                headers: {
                    "Use-Virtual-Session": true
                }
            });
    }

    getRolesProductById (productId) {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + "product/getRolesByProduct/" + productId);
    }
}

export default new ProductService;
